import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { getCookie } from "../../../slidebar/components/DarkMode";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/PromotionAction";
import { CopyToClipboard } from "../../../../utils/CommonHelper";

export const VoucherList = ({
  setShow,
  show,
  promotionId,
  setSwalProps,
  setPromotionId,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const columnClass = "p-3";

  const promotionState = useSelector(
    ({ promotion }) => promotion,
    shallowEqual
  );

  const handleClose = () => {
    setShow(false);
    setPromotionId(undefined);
  };

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    if (show && promotionId) {
      dispatch(actions.fetchVoucherList({ promotionid: promotionId }));
      return () => dispatch(actions.clearVoucherList());
    }
  }, [show, promotionId]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "voucherList",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow"
            style={{
              border: "1px solid grey",
              padding: "2px",
              margin: "10px 0px",
            }}
          >
            <div className="w-100">
              <table className="text-start table-report w-100">
                <tbody>
                  <tr>
                    <td className="col-3  td-line">
                      {intl.formatMessage({ id: "totalGenerated" })} :{" "}
                      {promotionState.voucherNotUseLists?.totalgent}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "totalUsed" })} :{" "}
                      {promotionState.voucherNotUseLists?.totaluse}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            className="rounded table-responsive"
            style={{ background: "var(--table-background)" }}
          >
            <table className="w-100">
              <thead>
                <tr className="border-bottom">
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "voucherId" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "action" })}
                  </th>
                </tr>
              </thead>
              <tbody>
                {promotionState.voucherNotUseLists ? (
                  promotionState.voucherNotUseLists.voucherNotUseLists.length >
                  0 ? (
                    promotionState.voucherNotUseLists.voucherNotUseLists.map(
                      (voucher, index) => (
                        <tr key={voucher.voucherid} className="border-bottom">
                          <td className={columnClass}>{index + 1}</td>
                          <td className={columnClass}>{voucher.voucherid}</td>
                          <td className={columnClass}>
                            <button
                              className="btn btn-warning me-1"
                              onClick={() => {
                                CopyToClipboard(
                                  voucher.voucherid,
                                  setSwalProps,
                                  intl
                                );
                              }}
                            >
                              <i className="bi bi-copy"></i>
                            </button>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan={3} className={`text-center ${columnClass}`}>
                        {intl.formatMessage({ id: "noRecordFound" })}
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td colSpan={3} className={columnClass}>
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                          <span className="sr-only"></span>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
